'use client';

import { Stack, Typography, Divider, Button } from '@castlery/fortress';
import { type CouponItemType } from '../coupon-dropdown/helper';
import { CouponTooltip } from '../coupon-tooltip/coupon-tooltip';
import dayjs from 'dayjs';

interface CouponOptionItemProps {
  coupon: CouponItemType;
}
export const CouponOptionItem = ({ coupon }: CouponOptionItemProps) => {
  const {
    couponType,
    code,
    min_spend,
    expired_at,
    unavailable_reason,
    title,
    highlightedCode,
    description,
    isHighest,
    calculators,
    descriptionInfo,
    cost,
  } = coupon;

  const expiredDate =
    expired_at && new Date(expired_at) instanceof Date
      ? dayjs(expired_at).subtract(1, 'day').format('MMM D, YYYY')
      : 'Forever';

  return (
    <>
      <Stack sx={{ flex: 1, width: 'calc(100% - 92px)', mr: 0.5 }}>
        <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: 0.5 }}>
          <Typography level="subh2" noWrap>
            {title}
          </Typography>
          {description && !isHighest ? (
            <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: 0.5 }}>
              <Typography level="caption2">Upgrade</Typography>
              {calculators?.length === 1 && <CouponTooltip title={descriptionInfo} />}
            </Stack>
          ) : null}
        </Stack>

        {!description && Number(min_spend) > 0 && <Typography level="caption2">min. spend ${min_spend}</Typography>}
        <Typography level="caption2">Valid Till: {expiredDate}</Typography>
      </Stack>
      <Divider orientation="vertical" sx={{ flex: 'none' }} />
      {couponType === 'coupon' && (
        <Stack sx={{ flex: 'none', width: 75 }}>
          {!!unavailable_reason && <CouponTooltip title={unavailable_reason} />}
          <Typography
            level="caption2"
            noWrap
            sx={{
              fontWeight: 700,
              textAlign: 'center',
            }}
          >
            {highlightedCode || code}
          </Typography>
        </Stack>
      )}
      {couponType === 'credits' && (
        <Stack sx={{ flex: 'none', width: 75, gap: 0.5 }}>
          <Typography
            level="caption2"
            noWrap
            sx={{
              textAlign: 'center',
            }}
          >
            {cost} Credits
          </Typography>
          <Button
            variant="tertiary"
            color="primary"
            sx={{
              fontSize: 'sm',
              minHeight: '24px',
              p: 0,
              textAlign: 'center',
              fontWeight: 600,
            }}
          >
            Redeem
          </Button>
        </Stack>
      )}
    </>
  );
};

export default CouponOptionItem;
